import React, { useState } from 'react';
import './FAQs.css';

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqsData = [
    {
      category: 'Account & Profile Related',
      questions: [
        {
          id: 1,
          question: 'Confidentiality and security of personal data ensured at all times',
          answer: (
            <>
              <p>
                Data privacy and security are our primary concerns.
                Each market survey is analysed anonymously and the
                results are accumulated at a level. While conducting
                market research for any clients, we ensure that the
                client only receives the anonymized results of the
                study. No personal data is made available to anyone
                at any stage.
              </p>
              <p>
                We here at Track Opinion Research Private Limited
                (Track Opinion), Gurugram, Haryana, India, 122018
                securely process and store your personal data.
              </p>
            </>
          )
        },
        {
          id: 2,
          question: 'Data collected in compliance with all the strict legal requirements',
          answer: (
            <p>
              Track Opinion processes all your personal information as
              legally stated by privacy and data protection rules of
              the geographic region you reside in. Whenever we share
              any personal information with third parties we make sure
              that privacy and legal requirements are completely
              aligned with them. While collecting, gathering and
              processing personal information from any territory we
              make sure that our legal team is working within the
              framework of legal requirements of the region.
            </p>
          )
        },
        {
          id: 3,
          question: 'My profile and the information accessed',
          answer: (
            <p>
              You are free to check the information Dive-in Panels has
              regarding you at any time via the 'My Account' or
              'Profile' tab on the panel pages.
            </p>
          )
        },
        {
          id: 4,
          question: 'How can I check my information at any time?',
          answer: (
            <p>
              You can access all your personal information via the
              'My Account' tab on the panel pages. You can review
              all information from this tab and keep a check on
              the information we have.
            </p>
          )
        },
        {
          id: 5,
          question: 'Privileges of Membership and the various uses of registered information',
          answer: (
            <>
              <p>
                The moment you become a member of Dive-in Panels, you
                give Us the right to analyse data entered in your
                profile as well as the answers of survey questions.
                All the data is anonymized so any names, postal or
                email addresses, or any kind of personal information
                will not be disclosed to any customer without the
                prior consent of the user. Each survey participant
                gets to answer the studies they want to.
              </p>
              <p>
                You can withdraw your data sharing privileges at any
                point. Track Opinion never stores and processes
                personal data without your consent. To opt out, just
                exit the panel. You can also delete your account by
                logging in, then going to the profile settings, and
                deleting the account.
              </p>
              <p>
                We meticulously monitor our user activity. If our
                system detects uneventful activity like answering
                inaccurately, making fraudulent answers, etc. we
                will notify the suspected members immediately
                without any prior notice. Our system always checks
                response patterns and response time.
              </p>
              <p>
                We strictly prohibit using more than one user
                account or email address to register to the panel.
                Any multiple accounts detected will be deleted
                without prior notice to the user.
              </p>
            </>
          )
        },
        {
          id: 6,
          question: 'How can I unsubscribe and delete my data?',
          answer: (
            <>
              <p>
                As long as you wish to remain a member of
                Dive-in Panels, your profile and the associated
                information will be stored safely with us. Whenever
                you choose to unsubscribe from Dive-in Panels's panel,
                all your information will be deleted within a
                reasonable period of time.
              </p>
              <p>
                For instance, data files are stored to ensure that a
                member doesn't receive multiple invites to the same
                market survey. Every data file of this type will be
                deleted after 6 months. In specific cases, these
                data files may be stored for 24 months for follow-up
                studies. Only our internal systems and processes use
                these data files.
              </p>
            </>
          )
        },
        {
          id: 7,
          question: 'Rewards',
          answer: (
            <p>
              The points collected on our system can be redeemed
              for products, donations and electronic coupons.
              These Dive-in Panels points are allocated to a User ID.
              Dive-in Panels points redeemed for electronic coupons
              will require the exchange of a user ID with our
              system supplier. We will only collect and share information that is
              required to complete the transaction.
            </p>
          )
        },
        {
          id: 8,
          question: 'Use of cookies',
          answer: (
            <p>
              Cookies are small text files generated in a device
              once a website is used. These cookies give visitor
              access to the website enabling features like logging
              in and checking previous website activity.
            </p>
          )
        },
        {
          id: 9,
          question: 'Member site cookies and cookies on surveys',
          answer: (
            <p>
              Track Opinion and the Dive-in Panels panel use cookies
              to manage logins on our site and in some of our
              surveys as well to provide a better service.
            </p>
          )
        }
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <div className="faqs-page">
      {/* Hero Banner */}
      <section className="policy-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Frequently Asked Questions</h1>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <figure className="policy-image">
                <img src="/assets/images/data-protection.svg" alt="FAQs" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs Content */}
      <section className="faqs-content">
        <div className="container">
          {faqsData.map((category, catIndex) => (
            <div key={catIndex} className="faq-category">
              <h2 className="category-title">{category.category}</h2>
              <div className="accordion">
                {category.questions.map((faq, index) => {
                  const globalIndex = catIndex * 100 + index;
                  return (
                    <div key={faq.id} className="accordion-item">
                      <div
                        className={`accordion-header ${
                          activeIndex === globalIndex ? 'active' : ''
                        }`}
                        onClick={() => toggleAccordion(globalIndex)}
                      >
                        <h3>
                          {faq.id}. {faq.question}
                        </h3>
                        <span className="accordion-icon">
                          {activeIndex === globalIndex ? '−' : '+'}
                        </span>
                      </div>
                      <div
                        className={`accordion-body ${
                          activeIndex === globalIndex ? 'show' : ''
                        }`}
                      >
                        <div className="accordion-content">{faq.answer}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FAQs;

